<template>
  <div>
    <v-footer
      id="home-footer"
      color="grey darken-4"
      dark
      min-height="72"
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
              <v-btn
                v-show="$t('TERMS_AND_CONDITIONS_PARAGRAPH_1')"
                class="white--text pa-1 pa-md-0"
                text
                @click="showTerms()"
                v-text="$t('TERMS_AND_CONDITIONS_BUTTON_TEXT')"
              />

              <v-responsive
                class="mx-4 shrink hidden-sm-and-down"
                max-height="24"
              >
                <v-divider vertical />
              </v-responsive>
              <v-btn
                class="white--text pa-1 pa-md-0"
                text
                @click="showPrivacy()"
                v-text="$t('PRIVACY_POLICY_BUTTON_TEXT')"
              />

              <v-responsive
                class="mx-4 shrink hidden-sm-and-down"
                max-height="24"
              >
                <v-divider vertical />
              </v-responsive>
            </div>
          </v-col>

          <v-col
            class="text-center text-md-right"
            cols="12"
            md="6"
          >
            Powered by <v-icon>mdi-camera</v-icon> Adent Health
          </v-col>
        </v-row>
      </v-container>
    </v-footer>

    <v-dialog
      v-model="iframeDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          color="grey lighten-3"
        >
          <v-progress-linear
            :active="true"
            :indeterminate="loading"
            absolute
            bottom
            color="primary"
          />
          <v-spacer />
          <v-btn
            icon
            light
            @click="iframeDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div
          id="frame-sheet"
          ref="frameSheet"
        >
          <v-sheet
            :height="iframeHeight"
          >
            <iframe
              width="100%"
              height="100%"
              frameborder="0"
              :src="activeIframeUrl"
            />
          </v-sheet>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="termsDialog"
      fullscreen
      hide-overlay
      eager
      transition="dialog-bottom-transition"
    >
      <v-card>
        <div>
          <v-toolbar
            id="frame-toolbar"
            ref="frameToolbar"
            color="grey lighten-3"
          >
            <v-spacer />
            <v-btn
              icon
              light
              @click="termsDialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </div>
        <terms-and-conditions />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import TermsAndConditions from '@/components/TermsAndConditions'

  export default {
    name: 'HomeFooter',
    components: {
      TermsAndConditions,
    },
    data: () => ({
      iframeDialog: false,
      termsDialog: false,
      iframeHeight: 0,
      activeIframeUrl: '',
      loading: false,
    }),
    watch: {
      loading (val) {
        if (!val) return
        setTimeout(() => (this.loading = false), 3000)
      },
    },
    methods: {
      showTerms () {
        this.termsDialog = true
      },
      showPrivacy () {
        this.iframeDialog = true
        this.loading = true
        this.calculateIframeHeight()
        this.loadLinkInIframe(this.$t('ADENT_PRIVACY_POLICY_LINK'))
      },
      calculateIframeHeight () {
        /** Implementation detail as of 2020/07/24 is that the toolbar height
         * is calculated from the Terms dialog for (assumed) faster loading.
         * Notice the 'eager' flag on the dialog, as this renders the dialog
         * on mount.
        */
        const toolbarHeight = this._getToolbarHeight()
        const windowHeight = window.innerHeight
        this.iframeHeight = windowHeight - toolbarHeight
      },
      _getToolbarHeight () {
        /** Currently hardcoded, have not succeeded to fetch dynamically via $refs.
         *
         * Dimensions from intrspection are:
         *   - 56px on small screens
         *   - 64px on bigger screens
         *
         * Using 64 leaves a slim white border in the bottom of the shown iframe
         * but it avoids any potential "overflow" (causing scroll) on the dialog.
         *
         * Intended style, but not working:
         *   `this.$refs.frameToolbar.clientHeight`
        */
        return 64
      },
      loadLinkInIframe (url) {
        this.activeIframeUrl = url // $t('PROVIDER_ABOUT_US_LINK')
      },
    },
  }
</script>

<style lang="sass">
  #home-footer a
    text-decoration: none
</style>
